/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { tns } from 'tiny-slider/src/tiny-slider';
import { displayMore } from './DisplayMore';
import { clamp } from '@clampy-js/clampy';

const triggers = Array.from(
    document.querySelectorAll('[data-toggle="menuToggle"]')
);
const triggerslevelTwoMenu = Array.from(
    document.querySelectorAll('[data-toggle="menuToggleLevel2"]')
);
const triggersSearchGlobal = Array.from(
    document.querySelectorAll('[data-toggle="searchGlobal"]')
);
const triggersCollapse = Array.from(
    document.querySelectorAll('[data-toggle="collapseElm"]')
);
const triggersAccordion = Array.from(
    document.querySelectorAll('[data-toggle="accordion"]')
);
const triggersDropdown = Array.from(
    document.querySelectorAll('[data-toggle="dropdownMenu"]')
);
let opened: null = null;

//Menu desktop
const initMenuHeight = () => {
    const navPanel: any = document.querySelector('.nav-panel.show');
    if (navPanel) {
        const currentMenuLink = navPanel.querySelector(
            'ul.level2 > li > a.current'
        );
        const levelTwoList = navPanel.querySelector('.level2');
        const quickAccess = navPanel.querySelector('.quick-access');
        const levelTwoHeight: number = levelTwoList.offsetHeight;
        const quickAccessHeight: number = quickAccess
            ? quickAccess?.offsetHeight
            : 0;
        if (currentMenuLink) {
            const currentMenuList = currentMenuLink.nextElementSibling;
            if (currentMenuList) {
                const currentMenuHeight: number = currentMenuList.offsetHeight;
                if (
                    currentMenuHeight > levelTwoHeight &&
                    currentMenuHeight > quickAccessHeight
                ) {
                    navPanel.style.height = currentMenuHeight + 'px';
                } else if (currentMenuHeight < quickAccessHeight) {
                    currentMenuList.style.height = quickAccessHeight + 'px';
                } else {
                    navPanel.style.height = 'auto';
                }
            }
        } else {
            if (levelTwoHeight < quickAccessHeight) {
                levelTwoList.style.height = quickAccessHeight + 'px';
            }
        }
    }
};

const setActiveLink = (firstLi: any) => {
    const navPanel: any = document.querySelector('.nav-panel.show');

    if (navPanel) {
        const current = navPanel.querySelector('ul.level2 > li > a.current');

        if (!current) {
            firstLi.classList.add('current');
            firstLi.setAttribute('aria-expanded', 'true');
        }
    }
};

const toggleVisibility = (target: any) => {
    target.classList.toggle('show');
    if (
        target.classList.contains('nav-panel') ||
        target.classList.contains('dropdown-menu')
    ) {
        const parent: any = target.previousElementSibling;
        parent.classList.toggle('active');
        if (parent.classList.contains('active')) {
            parent.setAttribute('aria-expanded', 'true');
        } else {
            parent.setAttribute('aria-expanded', 'false');
        }
    }
};

const menuToggle = (selector: any) => {
    const target: any = document.querySelector(selector);
    toggleVisibility(target);
    if (!opened) {
        opened = target;
    } else if (opened == target) {
        opened = null;
    } else {
        toggleVisibility(opened);
        opened = target;
    }
};

const levelTwoMenuToggle = (target: HTMLElement) => {
    const openPanel = target.closest('.nav-panel');

    if (!openPanel) {
        return;
    }

    const levelTwoLinks = openPanel.querySelectorAll<HTMLElement>(
        '.level2-link[data-toggle="menuToggleLevel2"]'
    );

    levelTwoLinks.forEach((link) => {
        const isActive = link === target;

        link.classList.toggle('current', isActive);
        link.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    menuHeight(target);
};

const menuHeight = (target: any) => {
    const navPanel: any = document.querySelector('.nav-panel.show');
    if (!navPanel.classList.contains('nav-panel-search')) {
        const levelThreeList = target.nextElementSibling;
        const levelThreeHeight: number = levelThreeList
            ? levelThreeList.offsetHeight
            : 0;
        const levelTwoList = navPanel.querySelector('.level2');
        const quickAccess = navPanel.querySelector('.quick-access');

        const levelTwoHeight: number = levelTwoList.offsetHeight;
        const quickAccessHeight: number = quickAccess.offsetHeight;

        if (
            levelThreeHeight > levelTwoHeight &&
            levelThreeHeight > quickAccessHeight
        ) {
            navPanel.style.height = levelThreeHeight + 'px';
        } else if (levelThreeHeight < quickAccessHeight) {
            if (levelThreeList) {
                levelThreeList.style.height = quickAccessHeight + 'px';
                navPanel.style.height = 'auto';
            } else {
                levelTwoList.style.height = quickAccessHeight + 'px';
                navPanel.style.height = 'auto';
            }
        } else if (levelTwoHeight < quickAccessHeight) {
            levelTwoList.style.height = quickAccessHeight + 'px';
            navPanel.style.height = 'auto';
        } else {
            navPanel.style.height = 'auto';
        }
    }
};

//searchPanel

const searchPanel = (selector: any) => {
    const target: any = document.querySelector(selector);
    toggleVisibility(target);
    if (!opened) {
        opened = target;
    } else if (opened == target) {
        opened = null;
    } else {
        toggleVisibility(opened);
        opened = target;
    }
};

//dropdown
const dropdownMenu = (elm: any) => {
    const target: any = elm.nextElementSibling;
    toggleVisibility(target);
    if (!opened) {
        opened = target;
    } else if (opened == target) {
        opened = null;
    } else {
        toggleVisibility(opened);
        opened = target;
    }
};

//collapse
const collapseElm = (selector: any) => {
    const targets = Array.from(document.querySelectorAll(selector));
    targets.forEach((target) => {
        target.classList.toggle('show');
        target.previousElementSibling.classList.toggle('active');
        const link: any =
            target.previousElementSibling.querySelector('.btn-filter');

        if (target.classList.contains('show')) {
            link.innerHTML = '<i class="icon-cross"></i>Masquer les filtres';
            link.setAttribute('aria-expanded', 'true');
        } else {
            link.innerHTML = '<i class="icon-filtre"></i>Affiner les résultats';
            link.setAttribute('aria-expanded', 'false');
        }
    });
};

//accordion
const initAccordion = (elm: any, accordionParent: any) => {
    const parent: any = document.querySelector(accordionParent);
    const panelsLinks = parent.querySelectorAll('.accordion-link');

    for (let i = 0; i < panelsLinks.length; i++) {
        const parentLink = panelsLinks[i].parentElement.parentElement;

        if (elm === panelsLinks[i] && !parentLink.classList.contains('open')) {
            parentLink.classList.add('open');
            panelsLinks[i].setAttribute('aria-expanded', true);
        } else {
            parentLink.classList.remove('open');
            panelsLinks[i].setAttribute('aria-expanded', false);
        }
    }
};

const handleClick = (e: any) => {
    const elm: any = e.target;
    const selector = elm.getAttribute('data-target');
    const accordionParent = elm.getAttribute('data-parent');
    const showNavPanel: any = document.querySelector('.nav-panel.show');
    const showSearchPanel: any = document.querySelector(
        '.search-panel-overlay.show'
    );
    const showDropdown: any = document.querySelector('.dropdown-menu.show');

    if (triggers.includes(elm)) {
        if (!elm.classList.contains('btn-search')) {
            const firstLi: any =
                elm.nextElementSibling.querySelector('.level2-link');
            if (
                firstLi.nextElementSibling &&
                firstLi.nextElementSibling.classList.contains('level3')
            ) {
                setTimeout(() => {
                    setActiveLink(firstLi);
                    initMenuHeight();
                }, 100);
            } else {
                setTimeout(() => {
                    initMenuHeight();
                }, 100);
            }
        }
        menuToggle(selector);
    } else if (triggerslevelTwoMenu.includes(elm)) {
        const target = e.target;
        levelTwoMenuToggle(target);
    } else if (triggersSearchGlobal.includes(elm)) {
        searchPanel(selector);
    } else if (triggersCollapse.includes(elm)) {
        collapseElm(selector);
    } else if (triggersAccordion.includes(elm)) {
        initAccordion(elm, accordionParent);
    } else if (triggersDropdown.includes(elm)) {
        dropdownMenu(elm);
    } else if (showDropdown) {
        if (showDropdown.contains(elm)) {
            e.stopPropagation();
        } else {
            showDropdown.classList.remove('show');
            showDropdown.previousElementSibling.classList.remove('active');
            showDropdown.previousElementSibling.setAttribute(
                'aria-expanded',
                'false'
            );
            opened = null;
        }
    } else if (showSearchPanel) {
        if (
            showSearchPanel.contains(elm) &&
            !elm.classList.contains('search-panel-backdrop')
        ) {
            e.stopPropagation();
        } else {
            showSearchPanel.classList.remove('show');
            opened = null;
        }
    } else if (showNavPanel) {
        if (showNavPanel.contains(elm)) {
            e.stopPropagation();
        } else {
            showNavPanel.classList.remove('show');
            showNavPanel.previousElementSibling.classList.remove('active');
            showNavPanel.previousElementSibling.setAttribute(
                'aria-expanded',
                'false'
            );
            opened = null;
        }
    }
};

document.addEventListener('click', handleClick);

// Menu mobile
const menuMobile: any = document.querySelector('#menu');
const toggleMenu: any = document.querySelector('.toggle-button');

if (menuMobile) {
    new SlideMenu(menuMobile, {
        position: 'left',
        backLinkBefore: '<i class="icon-angleLeft"></i>',
        submenuLinkAfter: '<i class="icon-angleRight"></i>',
    });

    menuMobile
        .querySelectorAll('.slide-menu__backlink')
        .forEach((backLink: HTMLAnchorElement) => {
            backLink.setAttribute('href', '#');
        });

    menuMobile.addEventListener('sm.open', function () {
        toggleMenu.classList.add('active');
        document.body.classList.add('menu-open');
    });

    menuMobile.addEventListener('sm.close', function () {
        toggleMenu.classList.remove('active');
        document.body.classList.remove('menu-open');
    });
}
//Sticky nav
const stickyNavScroll = () => {
    const stickyNavContainer: any = document.querySelector(
        '.sticky-nav-container'
    );
    const stickyNav: any = document.querySelector('.sticky-nav');
    const stickyNavContainerBottom: number =
        stickyNavContainer.offsetTop +
        (stickyNavContainer.offsetHeight - stickyNav.offsetHeight);
    if (
        window.pageYOffset > stickyNavContainer.offsetTop &&
        window.pageYOffset < stickyNavContainerBottom
    ) {
        if (stickyNav.classList.contains('bottom')) {
            stickyNav.classList.remove('bottom');
        } else {
            stickyNav.style.width = stickyNavContainer.offsetWidth - 30 + 'px';
            stickyNav.classList.add('sticky');
        }
    } else if (window.pageYOffset >= stickyNavContainerBottom) {
        stickyNav.classList.remove('sticky');
        stickyNav.classList.add('bottom');
    } else {
        if (stickyNav.classList.contains('sticky')) {
            stickyNav.classList.remove('sticky');
        }
    }
};

const resizeStickyNav = () => {
    const stickyNavContainer: any = document.querySelector(
        '.sticky-nav-container'
    );
    const stickyNav: any = document.querySelector('.sticky-nav');

    if (stickyNav.classList.contains('sticky')) {
        stickyNav.style.width = stickyNavContainer.offsetWidth - 30 + 'px';
    }
};

const scrollToAncor = () => {
    const navLinks = document.querySelectorAll('.sticky-nav a');
    navLinks.forEach((navLink: any) => {
        navLink.addEventListener('click', (e: any) => {
            e.preventDefault();
            if (document.activeElement) {
                (document.activeElement as HTMLElement).blur();
            }
            document.querySelector(navLink.hash).scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        });
    });
};

const scrollIndic = () => {};

const stickyNav: any = document.querySelector('.sticky-nav');
const scroller = document.querySelector('.theme-citizens');

if (scroller) {
    scroller.addEventListener('scroll', () => {
        if (stickyNav) {
            stickyNavScroll();
            scrollIndic();
        }
    });
}

window.addEventListener('DOMContentLoaded', () => {
    if (stickyNav) {
        stickyNavScroll();
        scrollIndic();
    }
});

window.addEventListener('resize', () => {
    if (stickyNav) {
        resizeStickyNav();
    }
});

/*Floating label*/

const FloatLabel = (() => {
    // add active class

    const handleFocus = (e: any) => {
        const target = e.target;

        target.parentNode.classList.add('active');

        target.setAttribute(
            'placeholder',
            target.getAttribute('data-placeholder') || ''
        );
    };

    // remove active class

    const handleBlur = (e: any) => {
        const target = e.target;

        if (!target.value) {
            target.parentNode.classList.remove('active');
        }

        target.removeAttribute('placeholder');
    };

    // register events

    const bindEvents = (element: HTMLElement) => {
        const floatField =
            element.querySelector('input') ||
            element.querySelector('select') ||
            element.querySelector('textarea');

        floatField?.addEventListener('focus', handleFocus);

        floatField?.addEventListener('blur', handleBlur);
    };

    // get DOM elements

    const init = () => {
        const floatContainers = document.querySelectorAll('.float-container');

        for (let i = 0, ic = floatContainers.length; i < ic; i++) {
            const element: any = floatContainers[i];

            if (
                (
                    element.querySelector('input') ||
                    element.querySelector('select') ||
                    element.querySelector('textarea')
                ).value
            ) {
                element.classList.add('active');
            }

            bindEvents(element);
        }
    };

    return {
        init: init,
    };
})();

const UmbFloatLabel = (() => {
    // add active class

    const handleFocus = (target: any, placeholder: any) => {
        target.parentNode.parentNode.classList.add('active');

        target.setAttribute('placeholder', placeholder || '');
    };

    // remove active class

    const handleBlur = (target: any) => {
        if (!target.value) {
            target.parentNode.parentNode.classList.remove('active');
            target.removeAttribute('placeholder');
        }
    };

    // register events

    const bindEvents = (element: any) => {
        const placeholder = (
            element.querySelector('input') ||
            element.querySelector('select') ||
            element.querySelector('textarea')
        ).getAttribute('placeholder');
        const floatField =
            element.querySelector('input') ||
            element.querySelector('select') ||
            element.querySelector('textarea');

        if (
            (
                element.querySelector('input') ||
                element.querySelector('select') ||
                element.querySelector('textarea')
            ).getAttribute('placeholder')
        ) {
            (
                element.querySelector('input') ||
                element.querySelector('select') ||
                element.querySelector('textarea')
            ).removeAttribute('placeholder');
        }

        floatField.addEventListener('focus', (e: any) => {
            const target = e.target;
            handleFocus(target, placeholder);
        });

        floatField.addEventListener('blur', (e: any) => {
            const target = e.target;
            handleBlur(target);
        });
    };

    // get DOM elements

    const init = () => {
        const floatContainers = document.querySelectorAll(
            '.umbraco-forms-field'
        );

        for (let i = 0, ic = floatContainers.length; i < ic; i++) {
            const element: any = floatContainers[i];

            if (
                element.querySelector('input') ||
                element.querySelector('select') ||
                element.querySelector('textarea')
            ) {
                if (
                    (
                        element.querySelector('input') ||
                        element.querySelector('select') ||
                        element.querySelector('textarea')
                    ).value != ''
                ) {
                    element.classList.add('active');
                }

                bindEvents(element);
            }
        }
    };

    return {
        init: init,
    };
})();

const UmbDateFloatLabel = (() => {
    // add active class

    const handleFocus = (target: any) => {
        target.parentNode.parentNode.classList.add('active');
    };

    // remove active class

    const handleBlur = (target: any) => {
        if (!target.value) {
            target.parentNode.parentNode.classList.remove('active');
        }
    };

    // register events

    const bindEvents = (element: any) => {
        const floatField = element.querySelector('input[type="text"]');

        floatField.addEventListener('focus', (e: any) => {
            const target = e.target;
            handleFocus(target);
        });

        floatField.addEventListener('blur', (e: any) => {
            const target = e.target;
            handleBlur(target);
        });
    };

    // get DOM elements

    const init = () => {
        const floatContainers = document.querySelectorAll(
            '.umbraco-forms-field.date'
        );

        for (let i = 0, ic = floatContainers.length; i < ic; i++) {
            const element: any = floatContainers[i];

            if (element.querySelector('input[type="text"]')) {
                if (element.querySelector('input[type="text"]').value != '') {
                    element.classList.add('active');
                }

                bindEvents(element);
            }
        }
    };

    return {
        init: init,
    };
})();

const fileInputUi = (() => {
    const fileUploads = document.querySelectorAll<HTMLElement>('.fileupload');

    const handleInput = (fileUploadContainer: HTMLElement) => {
        const fileUpload =
            fileUploadContainer.querySelector<HTMLInputElement>(
                'input[type="file"]'
            );

        if (
            fileUpload &&
            fileUpload.type == 'file' &&
            fileUpload.dataset.target
        ) {
            const files = document.querySelector<HTMLDivElement>(
                '[id="' + fileUpload.dataset.target + '"]'
            );
            fileUpload.name = '';
            fileUpload.addEventListener('change', function () {
                if (files && this.files) {
                    const file = this.cloneNode(true) as HTMLInputElement;
                    const parentNode = this.parentNode as HTMLInputElement;
                    if (parentNode) {
                        parentNode.insertBefore(file, files);
                    }
                    this.id = '';
                    if (files.dataset.name) {
                        this.name = files.dataset.name;
                    }
                    const node = document.createElement('div');
                    node.classList.add('file');
                    node.innerHTML = `<span>${this.files[0].name}</span><button class="clear" type="button"><i class="icon-cross"></i></button>`;
                    node.appendChild(this);
                    this.style.display = 'none';
                    files.appendChild(node);
                    handleClear();
                    handleInput(fileUploadContainer);
                }
            });
        }
    };

    const handleFocus = (fileUpload: any, label: any) => {
        const input = fileUpload.querySelector('input');

        input.addEventListener('focus', () => {
            label.classList.add('is-focused');
        });
    };

    const handleBlur = (fileUpload: any, label: any) => {
        const input = fileUpload.querySelector('input');

        input.addEventListener('blur', () => {
            label.classList.remove('is-focused');
        });
    };

    const handleClear = () => {
        const buttonsClear =
            document.querySelectorAll<HTMLButtonElement>('.clear');
        buttonsClear.forEach((buttonClear: HTMLButtonElement) => {
            if (buttonsClear) {
                buttonClear.addEventListener('click', function () {
                    const toDelete: HTMLElement | null = this.parentElement;
                    if (toDelete) toDelete.remove();
                });
            }
        });
    };

    const buildUi = () => {
        fileUploads.forEach((fileUpload) => {
            const label: HTMLElement | null = fileUpload.querySelector(
                '.umbraco-forms-label'
            );

            const valueContainer = document.createElement('span');
            const textContainer = document.createElement('span');

            valueContainer.classList.add('value');
            textContainer.classList.add('label-text');

            if (label) {
                const labelText = label.textContent;
                label.innerHTML = '';
                label.appendChild(valueContainer);
                label.appendChild(textContainer);
                textContainer.textContent = labelText;
            }

            handleInput(fileUpload);
            handleClear();
            handleFocus(fileUpload, label);
            handleBlur(fileUpload, label);
        });
    };

    return {
        init: buildUi,
    };
})();

const ScrollToErroForm = (() => {
    const scrollToFirstError = (error: HTMLElement) => {
        error.scrollIntoView({ behavior: 'smooth' });
    };

    const checkIfError = () => {
        const error = document.querySelector('.input-validation-error');

        if (error) {
            scrollToFirstError(error as HTMLElement);
        }
    };

    const formSubmit = () => {
        const forms = document.querySelectorAll('.umbraco-forms-form form');

        forms.forEach((form: any) => {
            if (form.querySelector('input[type="submit"]')) {
                form.querySelector('input[type="submit"]')!.addEventListener(
                    'click',
                    checkIfError
                );
            }
        });
    };

    return {
        init: formSubmit,
    };
})();

const scrollDown = () => {
    const btn: any = document.querySelector('.btn-down');

    if (btn) {
        const selector = btn.hash;
        const target = document.querySelector(selector);
        btn.addEventListener('click', (e: Event) => {
            e.preventDefault();
            target.scrollIntoView({
                behavior: 'smooth',
            });
        });
    }
};

window.addEventListener('DOMContentLoaded', () => {
    FloatLabel.init();
    UmbFloatLabel.init();
    fileInputUi.init();
    UmbDateFloatLabel.init();
    ScrollToErroForm.init();
    if (stickyNav) {
        scrollToAncor();
    }
    scrollDown();

    setSubmitButton.init();
    setNextButton.init();
    setEmailConfirmation.init();
    //multiFileInput.init();
    initScrollSpy();
});

//Slider partenaire footer desktop
// Slider partenaire footer desktop
const sliderPartner = document.querySelector('.partner');

if (sliderPartner) {
    const slider = tns({
        container: '.partner',
        loop: true,
        autoWidth: true,
        gutter: 10,
        controls: false,
        nav: false,
        autoplay: true,
        autoplayHoverPause: true,
        autoplayTimeout: 3500,
        swipeAngle: false,
        speed: 400,
        mouseDrag: false,
        center: true,
        autoplayText: ['▶', '❚❚'],
    } as any);

    const updatePartnerAccessibility = () => {
        document
            .querySelectorAll<HTMLElement>('.partner .tns-item')
            .forEach((slide) => {
                const isHidden = slide.getAttribute('aria-hidden') === 'true';

                slide
                    .querySelectorAll<HTMLElement>(
                        'a, button, input, select, textarea'
                    )
                    .forEach((element) => {
                        if (isHidden) {
                            element.setAttribute('tabindex', '-1');
                        } else if (element.getAttribute('tabindex') === '-1') {
                            element.removeAttribute('tabindex');
                        }
                    });
            });
    };

    updatePartnerAccessibility();

    slider.events.on('indexChanged', updatePartnerAccessibility);
    slider.events.on('transitionEnd', updatePartnerAccessibility);

    setTimeout(() => {
        const sliderNoAriaLive = document.querySelector('.tns-liveregion');

        if (sliderNoAriaLive) {
            sliderNoAriaLive.removeAttribute('aria-live');
        }

        updatePartnerAccessibility();
    }, 1000);
}

//Slider employer desktop grid
const employerSlider = Array.from(
    document.querySelectorAll('.umb-grid .employer-bloc')
);

employerSlider.forEach((employSlider) => {
    if (employSlider) {
        tns({
            container: employSlider,
            loop: true,
            autoWidth: false,
            gutter: 0,
            controls: false,
            nav: false,
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 3500,
            swipeAngle: false,
            speed: 400,
            mouseDrag: true,
            preventScrollOnTouch: 'auto',
            lazyload: true,
            center: true,
            items: 1,
            autoplayText: ['▶', '❚❚'],
        } as any);
    }
});

//Slider contenu mis en évidence mobile
const sliderPromu = document.querySelector('.slider-promu');
if (sliderPromu) {
    tns({
        container: '.slider-promu',
        items: 1,
        gutter: 0,
        controls: false,
        nav: true,
        navPosition: 'bottom',
        preventScrollOnTouch: 'auto',
        responsive: {
            '576': {
                items: 2,
                gutter: 20,
            },
            '768': {
                items: 3,
                gutter: 20,
            },
        },
    } as any);
}

//Slider employer mobile
const employerSliderMobile = document.querySelector(
    '.hp-slider .employer-bloc'
);
if (employerSliderMobile) {
    tns({
        container: '.hp-slider .employer-bloc',
        loop: true,
        autoWidth: false,
        gutter: 0,
        controls: false,
        nav: false,
        autoplay: true,
        autoplayHoverPause: true,
        autoplayTimeout: 3500,
        swipeAngle: false,
        speed: 400,
        mouseDrag: false,
        center: true,
        items: 1,
        autoplayText: ['▶', '❚❚'],
    } as any);
}

//Slider info mobile
const sliderInfosMobile = document.querySelectorAll(
    '.hp-slider .bloc-infos .slide'
);

if (sliderInfosMobile) {
    for (let i = 0; sliderInfosMobile.length > i; ++i) {
        tns({
            container: sliderInfosMobile[i],
            controls: false,
            nav: true,
            navPosition: 'bottom',
            responsive: {
                '768': {
                    items: 2,
                    gutter: 20,
                },
            },
        } as any);
    }
}

// Clamp functionality
const clampElements = document.querySelectorAll<HTMLElement>('[data-clamp]');

if (clampElements) {
    clampElements.forEach((e) => {
        let className = e.dataset.clamp;
        if (!className) {
            className = 'content';
        }

        const contentItems = e.getElementsByClassName(className);
        if (contentItems.length != 1) {
            console.log(
                'data-clamp is not working properly because you apply the process on more than one occurence'
            );
            return;
        }

        let otherContentHeight = 0;
        Array.from(e.children).forEach((c) => {
            if (c.className != className) {
                const cStyle = window.getComputedStyle(c);
                otherContentHeight +=
                    parseIntSafe(cStyle.height) +
                    parseIntSafe(cStyle.marginTop) +
                    parseIntSafe(cStyle.marginBottom);
            }
        });

        const style = window.getComputedStyle(e);
        const contentHeight =
            parseIntSafe(style.height) -
            parseIntSafe(style.paddingTop) -
            parseIntSafe(style.paddingBottom) -
            otherContentHeight;

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        const contentClamp = clamp(contentItems[0], {
            clamp: contentHeight + 'px',
        });
        if (contentClamp.clamped) {
            // little hack to be sure to not cut off a word
            const chunks = contentClamp.clamped.split(' ');
            if (chunks.length > 1) {
                chunks.pop();
                contentItems[0].innerHTML = chunks.join(' ') + '…';
            }
        }
    });
}

function parseIntSafe(content: string | null): number {
    return content ? parseInt(content) || 0 : 0;
}

//disable submit button
const setSubmitButton = (() => {
    const umbForm: HTMLDivElement | null = document.querySelector(
        '.umbraco-forms-form'
    );
    const noEligibleElements: NodeList | null = document.querySelectorAll(
        '.umbraco-forms-field.noeligible'
    );

    const clickListeners = () => {
        if (umbForm) {
            umbForm.querySelectorAll('input').forEach((inputEl) => {
                inputEl.addEventListener('click', () => {
                    setTimeout(checkIfExist, 100);
                });
            });
        }
    };

    const checkIfExist = () => {
        if (umbForm && noEligibleElements) {
            const submitButton: HTMLInputElement | null = umbForm.querySelector(
                'input[data-action="submit"]'
            );
            const nextButton: HTMLInputElement | null = umbForm.querySelector(
                'input[data-action="nextPage"]'
            );
            const areVisible: Array<number> = [];

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            noEligibleElements.forEach(
                (noEligibleEl: HTMLDivElement, index: number) => {
                    const noEligibleStyle =
                        window.getComputedStyle(noEligibleEl);
                    const display: string =
                        noEligibleStyle.getPropertyValue('display');

                    if (display == 'block') {
                        areVisible.push(index);
                        noEligibleEl.scrollIntoView({
                            behavior: 'smooth',
                        });
                    } else {
                        return;
                    }

                    return areVisible;
                }
            );

            if (areVisible.length > 0 && submitButton) {
                submitButton.disabled = true;
            } else if (areVisible.length == 0 && submitButton) {
                submitButton.disabled = false;
            }

            if (areVisible.length > 0 && nextButton) {
                nextButton.disabled = true;
            } else if (areVisible.length == 0 && nextButton) {
                nextButton.disabled = false;
            }
        }
    };

    return {
        init: clickListeners,
    };
})();

//disable next button
const setNextButton = (() => {
    const umbForm: HTMLDivElement | null = document.querySelector(
        '.umbraco-forms-form'
    );
    const noEligibleElements: NodeList | null = document.querySelectorAll(
        '.umbraco-forms-field.noeligibles'
    );

    const clickListeners = () => {
        if (umbForm) {
            umbForm.querySelectorAll('input').forEach((inputEl) => {
                inputEl.addEventListener('click', () => {
                    setTimeout(checkIfExist, 100);
                });
            });
        }
    };

    const checkIfExist = () => {
        if (umbForm && noEligibleElements) {
            const nextButton: HTMLInputElement | null = umbForm.querySelector(
                'input[data-action="nextPage"]'
            );
            const areVisible: Array<number> = [];

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            noEligibleElements.forEach(
                (noEligibleEl: HTMLDivElement, index: number) => {
                    const noEligibleStyle =
                        window.getComputedStyle(noEligibleEl);
                    const display: string =
                        noEligibleStyle.getPropertyValue('display');

                    if (display == 'block') {
                        areVisible.push(index);
                    } else {
                        return;
                    }

                    return areVisible;
                }
            );

            if (areVisible.length > 0 && nextButton) {
                nextButton.disabled = true;
            } else if (areVisible.length == 0 && nextButton) {
                nextButton.disabled = false;
            }
        }
    };

    return {
        init: clickListeners,
    };
})();

const setEmailConfirmation = {
    init() {
        const umbForm = document.querySelector<HTMLDivElement>(
            '.umbraco-forms-form'
        );

        if (!umbForm) return;

        const confirmationEmail = umbForm.querySelector<HTMLInputElement>(
            'input[data-confirmationemail="confirmationemail"]'
        );

        if (!confirmationEmail) return;

        confirmationEmail.onpaste = (e) => {
            e.preventDefault();
            return false;
        };
    },
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
document
    .querySelectorAll('[data-action="readMore"]')
    .forEach((elementHtmlTag: HTMLElement) => {
        displayMore.init(elementHtmlTag);
    });

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
document
    .querySelectorAll('[data-action="closeAlertBanner"]')
    .forEach((button: HTMLElement) => {
        const banner: HTMLElement | null = button.closest('.alert-banner');

        if (button) {
            button.addEventListener('click', () => {
                if (banner) {
                    banner.style.display = 'none';
                }
            });
        }
    });

// NEW STICKY CONTAINER AND PROGRESS BAR LOGIC

function getOffsetTop(el: HTMLElement): number {
    let offset = 0;

    while (el) {
        offset += el.offsetTop;
        el = el.offsetParent as HTMLElement;
    }

    return offset;
}

function initStickyNav(options: {
    containerSelector: string;
    navSelector: string;
}) {
    const container = document.querySelector<HTMLElement>(
        options.containerSelector
    );
    const nav = document.querySelector<HTMLElement>(options.navSelector);

    if (!container || !nav) return;

    const updateSticky = () => {
        const scrollTop = window.scrollY;
        const navHeight = nav.offsetHeight;

        nav.style.setProperty('--sticky-width', container.offsetWidth + 'px');

        const containerTop = getOffsetTop(container);
        const containerHeight = container.offsetHeight;
        const bottomLimit = containerTop + containerHeight - navHeight;

        if (scrollTop + 24 > containerTop && scrollTop < bottomLimit) {
            nav.classList.add('is-sticky');
            nav.classList.remove('is-bottom');
        } else if (scrollTop >= bottomLimit) {
            nav.classList.remove('is-sticky');
            nav.classList.add('is-bottom');
        } else {
            nav.classList.remove('is-sticky');
            nav.classList.remove('is-bottom');
        }
    };

    updateSticky();

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    window.addEventListener('load', updateSticky);
}

function initScrollSpy(navId = 'my-sticky-nav') {
    const nav = document.getElementById(navId);
    if (!nav) return;

    const items = Array.from(
        nav.querySelectorAll<HTMLLIElement>('li[data-scrollspy]')
    );

    const sections = items
        .map((li) => {
            const id = li.dataset.scrollspy;
            const section = id ? document.getElementById(id) : null;

            if (!section) return null;

            return { li, section };
        })
        .filter(
            (x): x is { li: HTMLLIElement; section: HTMLElement } => x !== null
        );

    const sectionMap = new Map<HTMLElement, HTMLLIElement>();

    sections.forEach(({ li, section }) => {
        sectionMap.set(section, li);
    });

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const li = sectionMap.get(entry.target as HTMLElement);
                if (!li) return;

                if (entry.isIntersecting) {
                    sections.forEach((s) => s.li.classList.remove('active'));
                    li.classList.add('active');
                }
            });
        },
        {
            rootMargin: '-20% 0px -70% 0px',
            threshold: 0,
        }
    );

    sections.forEach(({ section }) => observer.observe(section));

    function updateActiveState() {
        const line = window.innerHeight * 0.2;

        sections.forEach(({ li, section }) => {
            const rect = section.getBoundingClientRect();

            if (rect.top <= line && rect.bottom > line) {
                li.classList.add('active');
            } else {
                li.classList.remove('active');
            }
        });
    }

    requestAnimationFrame(() => {
        requestAnimationFrame(updateActiveState);
    });
}

initStickyNav({
    containerSelector: '.sticky-nav-container',
    navSelector: '.sticky-nav',
});

initScrollSpy('my-sticky-nav');
